import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const CustomThemeProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(() => {
        const saved = localStorage.getItem('dashboard-theme');
        return saved ? saved === 'dark' : true;
    });

    const toggleTheme = () => {
        setIsDark(prev => {
            const next = !prev;
            localStorage.setItem('dashboard-theme', next ? 'dark' : 'light');
            return next;
        });
    };

    useEffect(() => {
        document.body.className = isDark ? 'dark' : 'light';
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
            metaThemeColor.setAttribute('content', isDark ? '#0A0A0B' : '#FFFFFF');
        }
    }, [isDark]);

    const currentTheme = {
        background: isDark ? '#000000' : '#ffffff',
        cardBg: isDark ? '#111215' : '#ffffff',
        cardBorder: isDark ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.08)',
        textMain: isDark ? '#ffffff' : '#0f172a',
        textMuted: isDark ? 'rgba(255, 255, 255, 0.7)' : '#64748b',
        shadow: isDark ? '0 4px 6px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.05)',
        isDark: isDark
    };

    return (
        <ThemeContext.Provider value={{ isDark, toggleTheme, currentTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
